"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailToNoteContent = exports.emailForwardData = exports.emailReplyData = exports.insertEmailMarkup = exports.getHeaderValue = void 0;
// cspell:ignore roboto arial mailto
// tslint:disable:prefer-for-of
const buffer_1 = require("buffer");
const html_entities_1 = require("html-entities");
const _ = require("lodash");
const moment = require("moment");
const email_markup_constants_1 = require("./email-markup-constants");
const sanitize_html_1 = require("./sanitize-html");
const viewMoreButtonStyle = {
    cursor: 'pointer',
    'font-size': '1.6rem',
    'font-weight': '600',
    'margin-bottom': '8px',
    'margin-top': '8px'
};
const blockquoteStyle = 'margin: 0 0 0 .8ex; border-left: 1px #ccc solid; padding-left: 1ex';
const getSanitizedHtml = (window, base64Content, emailContentBlacklistedDomains, bodyText) => {
    const decoded = _.isEmpty(base64Content) ? '' : buffer_1.Buffer.from(base64Content, 'base64').toString('utf8');
    // Gmail's plain-text fallback is stored in both body and bodyText.
    const html = bodyText && base64Content === bodyText ? (0, html_entities_1.encode)(decoded) : decoded;
    let sanitized = (0, sanitize_html_1.sanitizeHtml)(window, html, emailContentBlacklistedDomains);
    // Remove tracking pixels
    const trackingUrls = [
        'https://track.getrocket.com/v1',
        'https://track.hireflow.ai/v1',
        'https://track.mixmax.com/api'
    ];
    const trackingUrlPattern = trackingUrls.join('|');
    const trackingPixelRegex = new RegExp(`<img[^>]*src=["'](?:${trackingUrlPattern})[^>]*>`, 'gi');
    sanitized = sanitized.replace(trackingPixelRegex, (match) => {
        const srcMatch = match.match(/src=["']([^"']*)["']/);
        if (srcMatch) {
            const originalSrc = srcMatch[1];
            return match.replace(`src="${originalSrc}"`, `src="" data-original-src="${originalSrc}"`);
        }
        return match;
    });
    // Wrap in pre tag if no child elements exist
    if (!/<[^>]+>/.test(sanitized)) {
        return `<pre style="font-family: 'Roboto', Arial;">${sanitized}</pre>`;
    }
    return sanitized;
};
const getHeaderValue = (headers) => (name) => {
    const header = headers.find((h) => h.name.toLowerCase() === name.toLowerCase());
    return header ? header.value : undefined;
};
exports.getHeaderValue = getHeaderValue;
const insertEmailMarkup = (window, base64Content, emailContainer, forwarded, emailContentBlacklistedDomains, attachments, bodyText) => {
    const container = window.document.createElement('div');
    container.className = email_markup_constants_1.emailContainerClass;
    if (_.isEmpty(base64Content)) {
        container.innerHTML = 'This message has no content';
        container.style.color = '#aaa';
        container.style.fontSize = '0.8rem';
    }
    else {
        const decodedContent = getSanitizedHtml(window, base64Content, emailContentBlacklistedDomains, bodyText);
        container.innerHTML = decodedContent;
        if (!forwarded) {
            const quotedElements = container.querySelectorAll('blockquote, .gmail_quote');
            for (let i = 0; i < quotedElements.length; i++) {
                const elem = quotedElements[i];
                elem.setAttribute('style', 'display: none');
            }
            if (quotedElements.length > 0) {
                const viewMore = window.document.createElement('div');
                viewMore.className = email_markup_constants_1.emailQuotesClass;
                viewMore.innerHTML = '···';
                Object.assign(viewMore.style, viewMoreButtonStyle);
                quotedElements[0].parentElement.insertBefore(viewMore, quotedElements[0]);
            }
        }
        const imageElements = container.getElementsByTagName('img');
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < imageElements.length; i += 1) {
            const el = imageElements[i];
            const src = el.getAttribute('src');
            if (src && src.match(/^cid:/)) {
                const contentId = src.split('cid:')[1];
                const cidImageAttachment = attachments.find((a) => a.contentId === contentId);
                if (cidImageAttachment === null || cidImageAttachment === void 0 ? void 0 : cidImageAttachment.path) {
                    const cidImageSrc = `https://files.getrocket.com/${cidImageAttachment.path
                        .split('/')
                        .map(encodeURIComponent)
                        .join('/')}`;
                    el.setAttribute('src', cidImageSrc);
                }
            }
        }
    }
    emailContainer.appendChild(container);
};
exports.insertEmailMarkup = insertEmailMarkup;
const emailReplyInitialContent = (window, data, emailContentBlacklistedDomains) => {
    const sender = data.headers.from;
    const senderName = sender.name;
    const dateInformation = 'On ' + moment(data.internalDate).format('ddd, MMM D, Y') + ' at ' + moment(data.internalDate).format('h:mm A');
    const senderEmail = sender.address;
    const content = `<div><br></div>
        <div><br></div>
        <div class='gmail_quote'>
            ${dateInformation}, ${senderName}
            <span dir="ltr">&lt;<a href=mailto:${senderEmail} target="_blank">${senderEmail}</a>&gt;</span> wrote:
        </div>
        <blockquote class='gmail_quote' style='${blockquoteStyle}'>${getSanitizedHtml(window, data.body, emailContentBlacklistedDomains, data.bodyText)}</blockquote>`;
    return content;
};
const emailForwardInitialContent = (window, data, emailContentBlacklistedDomains) => {
    const getAddressString = (e) => (e.name ? `${e.name} &lt;${e.address}&gt;` : e.address);
    const fwdInfo = [
        '--------- Forwarded message ---------',
        `From: ${getAddressString(data.headers.from)}`,
        `Date: ${moment(data.internalDate).format('ddd, MMM D, Y')} at ${moment(data.internalDate).format('h:mm A')}`,
        `Subject: ${data.subject}`,
        `To: ${data.headers.to.map(getAddressString).join(', ')}`
    ].join('<br>');
    const content = `<br><br>
        <div class='gmail_quote'>
            ${fwdInfo}
        </div>
        <div class='gmail_quote'><br></div>
        <blockquote class='gmail_quote' style='${blockquoteStyle}'>${getSanitizedHtml(window, data.body, emailContentBlacklistedDomains, data.bodyText)}</blockquote>`;
    return content;
};
const emailReplyData = (window, data, replyAll, emailContentBlacklistedDomains) => {
    const { from: oldFrom, to: oldTo, cc: oldCC } = data.headers;
    const sendFromAddress = data.account;
    const bcc = [];
    let to = [];
    if (oldFrom.address === sendFromAddress) {
        to = oldTo;
    }
    else {
        to = replyAll ? oldTo.concat([oldFrom]) : [oldFrom];
        to = to.filter((a) => a.address !== sendFromAddress);
    }
    if (to.length === 0) {
        to = [oldFrom];
    }
    const cc = replyAll ? oldCC.filter((newCC) => newCC.address !== sendFromAddress) : [];
    let subject = (data.subject || '')
        .trim()
        .replace(/^Re:\s*/i, '')
        .replace(/^Fwd:\s*/i, '');
    subject = 'Re: ' + subject;
    const replyBody = emailReplyInitialContent(window, data, emailContentBlacklistedDomains);
    const headers = { bcc, cc, to, subject };
    if (data.rawHeaders) {
        const messageId = (0, exports.getHeaderValue)(data.rawHeaders)('Message-ID');
        const references = (0, exports.getHeaderValue)(data.rawHeaders)('References') || '';
        headers.inReplyTo = messageId;
        headers.references = `${references} ${messageId}`;
    }
    else {
        headers.inReplyTo = data.referenceMessageId || undefined;
        headers.references = `${data.references || ''} ${data.referenceMessageId || ''}`.trim() || undefined;
    }
    return {
        headers,
        replyBody
    };
};
exports.emailReplyData = emailReplyData;
const emailForwardData = (window, data, emailContentBlacklistedDomains) => {
    const bcc = [];
    const to = [];
    const cc = [];
    let subject = (data.subject || '')
        .trim()
        .replace(/^Re:\s*/i, '')
        .replace(/^Fwd:\s*/i, '');
    subject = 'Fwd: ' + subject;
    const body = emailForwardInitialContent(window, data, emailContentBlacklistedDomains);
    const headers = { bcc, cc, to, subject };
    if (data.rawHeaders) {
        const messageId = (0, exports.getHeaderValue)(data.rawHeaders)('Message-ID');
        const references = (0, exports.getHeaderValue)(data.rawHeaders)('References') || '';
        headers.inReplyTo = messageId;
        headers.references = `${messageId} ${references}`;
    }
    return {
        body,
        headers
    };
};
exports.emailForwardData = emailForwardData;
const emailToNoteContent = (data) => {
    const htmlString = buffer_1.Buffer.from(data.body, 'base64').toString('utf8');
    const container = document.createElement('div');
    container.innerHTML = htmlString.trim();
    const quotedElements = container.querySelectorAll('blockquote, .gmail_quote');
    for (const elem of Array.from(quotedElements)) {
        elem.innerHTML = '';
    }
    const getAddressString = (e) => (e.name ? `${e.name} &lt;${e.address}&gt;` : e.address);
    const fwdInfo = [
        '--------- Note created from Email message ---------',
        `From: ${getAddressString(data.headers.from)}`,
        `Date: ${moment(data.internalDate).format('ddd, MMM D, Y')} at ${moment(data.internalDate).format('h:mm A')}`,
        `Subject: ${data.subject}`,
        `To: ${data.headers.to.map(getAddressString).join(', ')}`
    ].join('<br>');
    const content = `
        <div>
            ${fwdInfo}
        </div>
        <br/>
        <br/>
        <div>${container.outerHTML}</div>`;
    return content;
};
exports.emailToNoteContent = emailToNoteContent;
//# sourceMappingURL=email-markup.js.map